module.exports = __webpack_public_path__ + "static/img/putcontent_1.4a162ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ad/putcontent_1.png
// module id = wDvv
// module chunks = 1